import React from "react";
import { Box, Card, CardMedia, Chip, Typography, alpha, useTheme } from "@mui/material";
import { mediaSrc } from "../../../utils/mediaSrc";

/**
 * Compact selectable tile matching the Characters (influencers) page.
 */
export default function SelectableInfluencerTile({ influencer, selected, onSelect }) {
  const theme = useTheme();

  return (
    <Card
      onClick={onSelect}
      sx={{
        borderRadius: 2,
        overflow: "hidden",
        cursor: "pointer",
        border: "2px solid",
        borderColor: selected ? "primary.main" : "divider",
        boxShadow: selected ? 4 : 0,
      }}
    >
      <Box sx={{ position: "relative", pt: "125%", bgcolor: "grey.200" }}>
        {influencer.photo_url ? (
          <CardMedia
            component="img"
            image={mediaSrc(influencer.photo_url)}
            alt={influencer.name}
            sx={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "top",
            }}
          />
        ) : null}
        {influencer.category_name ? (
          <Chip
            label={influencer.category_name}
            size="small"
            sx={{
              position: "absolute",
              top: 6,
              left: 6,
              height: 20,
              fontSize: 10,
              fontWeight: 700,
              bgcolor: alpha(influencer.category_color || theme.palette.primary.main, 0.9),
              color: "#fff",
            }}
          />
        ) : null}
      </Box>
      <Box sx={{ p: 1 }}>
        <Typography variant="caption" fontWeight={800} display="block" noWrap>
          {influencer.name}
        </Typography>
      </Box>
    </Card>
  );
}
